import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Injector,
} from '@angular/core';
import { QuillViewComponent } from 'ngx-quill';
import Quill, { Delta } from 'quill';
import '../html-editor/custom-hr-blot'; // Import the custom blot
import '../html-editor/custom-font-size';
import { HtmlViewerDownloadService } from './html-viewer-download-service';
import { Subscription } from 'rxjs';
import '../html-editor/custom-hr-blot';
import {
  brMatcher,
  CustomBlotEvent,
  inputMatcher,
  setAngularInjector,
} from '../html-editor/custom-hr-blot';
@Component({
  imports: [QuillViewComponent],
  selector: 'rmp-html-viewer',
  standalone: true,
  templateUrl: './html-viewer.component.html',
  styleUrl: './html-viewer.component.scss',
})
export class HtmlViewerComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() content!: string;
  @Input() fullWidth = false;
  @Input() hasBorder = true;
  @Output() downloadRequested = new EventEmitter<ElementRef<any>>();
  @Output() blotEvent = new EventEmitter<CustomBlotEvent>(); // Emit blot events
  @ViewChild('baseContainer', { static: true })
  baseContainer!: QuillViewComponent;
  quillModules = {
    clipboard: {
      matchers: [
        ['br', brMatcher.bind(this)],
        ['input', inputMatcher.bind(this)],
      ],
    },
  };
  private downloadSubscription!: Subscription;
  constructor(
    private downloadService: HtmlViewerDownloadService,
    private injector: Injector,
  ) {
    setAngularInjector(this.injector); // Set the Angular injector for custom blots
  }
  ngAfterViewInit(): void {
    this.baseContainer.onEditorCreated.subscribe((editor: Quill) => {
      editor.root.addEventListener('change', (event: any) => {
        //check if event is custom blot event
        if (event.detail && event.detail.type) {
          this.blotEvent.emit(event.detail);
        } else {
          this.blotEvent.emit({
            type: event.target.type,
            id: event.target.id,
            name: event.target.name,
            value: event.target.checked ? 'checked' : event.target.value,
          });
        }
      });
    });
  }

  ngOnInit() {
    this.downloadSubscription =
      this.downloadService.downloadRequested$.subscribe(() => {
        this.downloadRequested.emit(this.baseContainer?.elementRef);
      });
  }

  ngOnDestroy() {
    if (this.downloadSubscription) {
      this.downloadSubscription.unsubscribe();
      this.downloadRequested.complete();
    }
  }
}
